export interface ServiceData {
  id: string;
  title: string;
  icon: string;
  shortDesc: string;
  whatsappMsg: string;
  problem: {
    title: string;
    desc: string;
  };
  mistakes: { title: string; desc: string }[];
  whyWorse: string;
  correctMethod: { step: string; desc: string }[];
  advantages: string[];
  trustNote?: string;
  ctaLabel: string;
}

export const services: ServiceData[] = [
  {
    id: 'koltuk',
    title: 'Koltuk Yıkama',
    icon: 'ri-sofa-line',
    shortDesc: 'Profesyonel ekipmanla derin temizlik, koku giderme ve dezenfeksiyon.',
    whatsappMsg: 'Merhaba, Koltuk Yıkama için randevu almak istiyorum.\nAd Soyad:\nTelefon:\nAdres:\nTarih:\nSaat:\nNot:',
    problem: {
      title: 'Koltuğunuz Göründüğünden Daha Kirli',
      desc: 'Koltuklar her gün binlerce bakteri, akar ve derin kiri biriktirir. Yüzeyin temiz görünmesi, içindeki kirliliği yok saymak anlamına gelir.',
    },
    mistakes: [
      { title: 'Leke Silmek', desc: 'Islak bez ile silmek kiri daha derine iter, leke kalıcı hale gelir.' },
      { title: 'Yanlış Kimyasal', desc: 'Genel amaçlı deterjanlar koltuk kumaşını bozabilir, renk solmasına neden olur.' },
      { title: 'Islak Bırakmak', desc: 'Koltuk tam kurumadan kullanılırsa küf ve kötü koku oluşur.' },
    ],
    whyWorse: 'İlk müdahaledeki hatalar kumaş liflerine işler; sonradan yapılan profesyonel temizlikte bile iz kalabilir. Ne kadar geç kalınırsa, leke o kadar derine işler.',
    correctMethod: [
      { step: 'Toz Alma', desc: 'Özel uçlarla derin vakumlama ile yüzey tozlardan arındırılır.' },
      { step: 'Şampuanlama', desc: 'Kumaş tipine özel üretilen kimyasal ile fırçalanır.' },
      { step: 'Extraction', desc: 'Karcher makinesi ile kirli su, kir ve kimyasal tam olarak çekilir.' },
      { step: 'Dezenfeksiyon', desc: 'Saphire dezenfektanı ile bakteri ve akarlar yok edilir.' },
    ],
    advantages: [
      'Alman Karcher Extraction Makinesi',
      'Özel üretim kumaş şampuanı',
      'Derin vakumlama sistemi',
      'Saphire dezenfektan uygulaması',
      'Evde hizmet, taşıma yok',
      '18 yıl tecrübeli ekip',
    ],
    ctaLabel: 'Koltuk Yıkama Randevusu Al',
  },
  {
    id: 'sandalye',
    title: 'Sandalye Yıkama',
    icon: 'ri-layout-column-line',
    shortDesc: 'Günlük kir, koku ve bakteri temizliği için derin yıkama hizmeti.',
    whatsappMsg: 'Merhaba, Sandalye Yıkama için randevu almak istiyorum.\nAd Soyad:\nTelefon:\nAdres:\nTarih:\nSaat:\nNot:',
    problem: {
      title: 'Sandalyeler Sessiz Kiri Taşır',
      desc: 'Yemek masası sandalyeleri yağ, gıda artığı ve beden teri ile sürekli kirlenir. Görünmese de, mikrop yükü oldukça yüksektir.',
    },
    mistakes: [
      { title: 'Sığ Temizlik', desc: 'Yüzey silimi derin kiri temizlemez; sadece görünümü iyileştirir.' },
      { title: 'Aşırı Nem', desc: 'Fazla suyla yıkama köpük ve sünger içinde koku bırakır.' },
      { title: 'Yanlış Ürün', desc: 'Mutfak deterjanı sandalye kumaşına zarar verebilir.' },
    ],
    whyWorse: 'Sandalyeler açık pozisyonda sürekli toz ve kir alır. Yüzeysel temizlik kiri içine hapseder; zamanla renk solar ve kumaş sertleşir.',
    correctMethod: [
      { step: 'Ön Vakum', desc: 'Kuru toz ve kırıntılar profesyonel vakum ile alınır.' },
      { step: 'Kimyasal Uygulama', desc: 'Kumaş tipine uygun temizleyici uygulanır, beklenir.' },
      { step: 'Derin Yıkama', desc: 'Karcher ile derin extraction işlemi yapılır.' },
      { step: 'Koku Giderme', desc: 'Dezenfektan ile koku kaynakları yok edilir.' },
    ],
    advantages: [
      'Tüm sandalye kumaş tiplerine uygun',
      'Hızlı kuruma teknolojisi',
      'Koku giderme garantisi',
      'Evde uygulama, hasar riski yok',
      'Mahal ve set sandalyeler için özel teknik',
    ],
    ctaLabel: 'Sandalye Yıkama Randevusu Al',
  },
  {
    id: 'yatak',
    title: 'Yatak Yıkama',
    icon: 'ri-hotel-bed-line',
    shortDesc: 'Derin leke temizliği, akar yok etme ve sağlıklı uyku ortamı.',
    whatsappMsg: 'Merhaba, Yatak Yıkama için randevu almak istiyorum.\nAd Soyad:\nTelefon:\nAdres:\nTarih:\nSaat:\nNot:',
    problem: {
      title: 'Yatağınız Neden Risk Taşır?',
      desc: 'Ortalama bir yatakta milyonlarca toz akarı yaşar. Ter ve vücut sıvıları zamanla sarı lekeler bırakır, koku oluşturur.',
    },
    mistakes: [
      { title: 'Yüzeysel Silim', desc: 'Islatıp silmek yalnızca yüzeyi etkiler; derin bakteri ve akarları yok etmez.' },
      { title: 'Uygunsuz Kimyasal', desc: 'Klorun veya çamaşır suyunun direkt uygulanması yatak ömrünü kısaltır.' },
      { title: 'Eksik Kurutma', desc: 'Yeterince kurutulmayan yatak küf üretir, solunum sorunlarına yol açabilir.' },
    ],
    whyWorse: 'Yatak materyali nem ve kiri içinde tutar. Ne kadar geç temizlenirse, sarı lekeler o kadar derine işler ve çıkması zorlaşır.',
    correctMethod: [
      { step: 'Şampuanlama', desc: 'Yatak yüzeyine özel şampuan uygulanır.' },
      { step: 'Vakumlama', desc: 'Yüzeyden kir ve toz alınır.' },
      { step: 'Leke Kimyasalı', desc: 'Leke bölgelerine özel kimyasal uygulanır, beklenir.' },
      { step: 'Fırçalama', desc: 'Dairesel hareketlerle kumaşa işlenir.' },
      { step: 'Çekme', desc: 'Karcher ile kirli su ve kimyasal tamamen çekilir.' },
      { step: 'Son Vakum', desc: 'Kalan nem ve kalıntılar için ikinci vakumlama yapılır.' },
    ],
    advantages: [
      'Toz akarı %99 yok etme',
      'Saphire dezenfektan kullanımı',
      'Alman Karcher makinesi',
      'Hızlı kuruma (2-3 saat)',
      '18 yıl yatak temizlik tecrübesi',
    ],
    trustNote: 'Önemli Not: Derine işlemiş bazı sarı lekeler tamamen çıkmayabilir. Bu tamamen dürüst bir bilgilendirmedir.',
    ctaLabel: 'Yatak Yıkama Randevusu Al',
  },
  {
    id: 'petek',
    title: 'Petek Temizliği',
    icon: 'ri-fire-line',
    shortDesc: 'Kombi filtre temizliği dahil, tam sistem petek temizleme hizmeti.',
    whatsappMsg: 'Merhaba, Petek Temizliği için randevu almak istiyorum.\nAd Soyad:\nTelefon:\nAdres:\nTarih:\nSaat:\nNot:',
    problem: {
      title: 'Kirli Petekler Hem Sağlığı Hem Faturayı Etkiler',
      desc: 'Yıllarca birikmiş tortu ve pas, peteklerin verimini düşürür. Daha fazla gaz harcar, daha az ısı üretir.',
    },
    mistakes: [
      { title: 'Dışını Silmek', desc: 'Petek yüzeyini silmek içindeki birikimi hiç etkilemez.' },
      { title: 'Kompresör Kullanmak', desc: 'Yanlış basınçla yapılan temizlik petek içini patlatabilir.' },
      { title: 'Geç Müdahale', desc: 'Pas ve tortunun birikmesi, sistemin tamamen değiştirilmesini gerektirebilir.' },
    ],
    whyWorse: 'Her ısınma sezonunda biriken tortu, peteklerin ısı iletimini düşürür. Kombi giderek daha fazla çalışır, fatura artar, ısınma azalır.',
    correctMethod: [
      { step: 'Isı Kontrolü', desc: 'Petek sıcaklıkları ölçülerek problemli radyatörler tespit edilir.' },
      { step: 'Kombiden Ayırma', desc: 'Sistem güvenli şekilde kapatılır ve izole edilir.' },
      { step: 'Makine Bağlantısı', desc: 'Özel basınçlı temizlik makinesi sisteme bağlanır.' },
      { step: 'Radyatör Temizliği', desc: 'Her radyatör tek tek, özel kimyasal ile temizlenir.' },
      { step: 'Ters Yönlü Temizlik', desc: 'Tortu ve pas kalıntılarının tamamı çıkarılır.' },
      { step: 'Kirli Su Boşaltma', desc: 'Sistem kirli suyu tamamen dışarı atar.' },
      { step: 'Kombi Filtre Temizliği', desc: 'Kombi iç filtresi de temizlenir, sistem kapsamlı olarak teslim edilir.' },
      { step: 'Kontrol', desc: 'Sistemin tüm petekleri tekrar kontrol edilir, sorun yoksa teslim.' },
    ],
    advantages: [
      'Kombi filtre temizliği dahil',
      '8 adımlı kapsamlı işlem',
      'Profesyonel basınçlı makine',
      'Her radyatör bireysel temizlik',
      'Enerji verimliliği artar',
      'Isınma sorunu çözülür',
    ],
    ctaLabel: 'Petek Temizliği Randevusu Al',
  },
];
